const emails = {
	support: 'support@fdna.com',
	research: 'research@fdna.com'
}

const emailWithMessage = {
    errorSigningUp: `mailto:${emails.support}?Subject=Error%20signing%20up%20to%20Face2Gene`,
    resetPassword: `mailto:${emails.support}?Subject=I%20can't%20reset%20my%20password`,
    interestInResearch: `mailto:${emails.research}?subject=I'm interested in research with GestaltMatcher`,
    mailToSupport: `mailto:${emails.support}`
}

module.exports = {
    emailWithMessage,
    emails
}


// WEBPACK FOOTER //
// ./common/staticMail.js